import React from 'react';
import GaugeComponent from 'react-gauge-component'
import { Arc } from 'react-gauge-component/dist/lib/GaugeComponent/types/Arc';
import './style.css';

interface ColProps {
  xs?: number;
  lg?: number;
}

interface TooltipProps {
  text: string;
  style?: React.CSSProperties
}

interface SubArcProps {
  limit?: number;
  length?: number;
  color?: string;
  showTick?: boolean;
  tooltip?: TooltipProps;
  onClick?: (event: any) => void;
  onMouseMove?: (event: any) => void;
  onMouseLeave?: (event: any) => void;
}

interface ArcProps {
  cornerRadius?: number;
  padding?: number;
  width?: number; //Default: "grafana": 0.25. "semicircle": 0.15 "radial": 0.2
  nbSubArcs?: number;
  colorArray?: string[];
  gradient?: boolean;
  subArcs?: SubArcProps[]; //subArcs: [{limit: 50}, {limit: 100}] this will render 2 arcs 50/50
}

interface PointerProps {
  type?: string | "needle" | "blob" | "arrow"; //default "needle"
  color?: string; //default "#464A4F"
  baseColor?: string; //default "#464A4F"
  length?: number; //default 0.70
  animate?: boolean; //default true
  elastic?: boolean; //default false
  animationDuration?: number; //default 3000
  animationDelay?: number; //default 100
  width?: number; //default 20
}

interface ValueLabelProps {
  matchColorWithArc?: boolean;
  formatTextValue?: (value: any) => string;
  style?: React.CSSProperties; //{fontSize: "35px", fill: "#fff", textShadow: "black 1px 1px 0px, black 0px 0px 2.5em, black 0px 0px 0.2em"}
  maxDecimalDigits?: number; //default 2
  hide?: boolean; //default false
}

interface TicksProps {
  value?: number;
  valueConfig?: TickValueProps;
  lineConfig?: TickLineProps;
}

interface TickValueProps {
  formatTextValue?: (value: any) => string;
  style?: React.CSSProperties;
  maxDecimalDigits?: number; //default 2
  hide?: boolean; //default false
}

interface TickLineProps {
  width?: number; //default 1
  length?: number; //default 7
  color?: string; //default rgb(173 172 171)
  distanceFromArc?: number; //default 3
  hide?: boolean; //default false
}

interface TickLabelProps {
  type?: string; //inner or outer default outer
  hideMinMax?: boolean; //default false
  ticks?: TicksProps[];
  valueConfig?: TickValueProps;
  lineConfig?: TickLineProps;
  defaultTickValueConfig?: TickValueProps;
  defaultTickLineConfig?: TickLineProps;
}

interface LabelProps {
  valueLabel?: ValueLabelProps;
  tickLabels?: TickLabelProps;
}

interface marginProps {
  left: number,
  right: number,
  top: number,
  bottom: number
}

interface GaugeProps {
  col?: ColProps;
  type?: "grafana" | "semicircle" | "radial";
  id?: string;
  className?: string;
  style?: React.CSSProperties;
  marginInPercent?: number | marginProps;
  value?: number;
  minValue?: number;
  maxValue?: number;
  arc?: ArcProps;
  pointer?: PointerProps;
  labels?: LabelProps;
}

const GaugeChartComponent: React.FC<GaugeProps> = ({
  type = 'grafana',
  id,
  className,
  value,
  style,
  minValue,
  maxValue,
  marginInPercent,
  arc,
  pointer,
  labels
}) => {
  return (
    <GaugeComponent
      type={type}
      id={id}
      className={className}
      value={value}
      style={style}
      minValue={minValue}
      maxValue={maxValue}
      marginInPercent={typeof marginInPercent !== 'object' ? marginInPercent :
        {
          left: marginInPercent?.left,
          right: marginInPercent?.right,
          top: marginInPercent?.top,
          bottom: marginInPercent?.bottom
        }}
      arc={arc as Arc}
      pointer={{ ...pointer, type: pointer?.type as "needle" | "blob" | "arrow" }}
      labels={{
        ...labels,
        tickLabels: {
          ...labels?.tickLabels,
          type: labels?.tickLabels?.type as "outer" | "inner" | undefined
        }
      }}
    />
  );
}

export default GaugeChartComponent;